// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing[Frida]NRuyx6QF","submotivation":"submotivation[Frida]1bPwxFv_","motivation":"motivation[Frida]KlUGuiUu"};